import { render, staticRenderFns } from "./mail-list-dialog.vue?vue&type=template&id=eb99858e&scoped=true"
import script from "./mail-list-dialog.vue?vue&type=script&lang=js"
export * from "./mail-list-dialog.vue?vue&type=script&lang=js"
import style0 from "./mail-list-dialog.vue?vue&type=style&index=0&id=eb99858e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb99858e",
  null
  
)

export default component.exports